/** @jsx jsx */
import { jsx } from "theme-ui"
import { useTranslation } from "react-i18next"
import { useStaticQuery, graphql } from "gatsby"
import { Flex } from "rebass"

import Button from "../Button"

import { ReactComponent as FacebookIcon } from "../../../images/icons/facebook.svg"
import { ReactComponent as TwitterIcon } from "../../../images/icons/twitter.svg"
import { ReactComponent as InstagramIcon } from "../../../images/icons/instagram.svg"
import { ReactComponent as LinkedinIcon } from "../../../images/icons/linkedin.svg"

const SocialLinks = props => {
  const { i18n } = useTranslation()
  const { sanitySiteSettings } = useStaticQuery(query)

  return (
    <Flex sx={{ alignItems: "center" }} {...props}>
      {sanitySiteSettings.socialLinks.twitter && ( 
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href={`https://twitter.com/${sanitySiteSettings.socialLinks.twitter}`}
          variant="bigPrimary"
          sx={{
            p: 2,
            ...(i18n.dir() === "rtl" ? { ml: 3 } : { ml: 0}),
          }}
        >
          <TwitterIcon height={14} width={14} alt="Follow us on Twitter" />
        </Button>
      )}
      {sanitySiteSettings.socialLinks.facebook && ( 
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href={`https://facebook.com/${sanitySiteSettings.socialLinks.facebook}`}
          variant="bigPrimary"
          sx={{
            ml: 3,
            p: 2,
          }}
        >
          <FacebookIcon height={14} width={14} alt="Follow us on Facebook" />
        </Button>
      )}
      {sanitySiteSettings.socialLinks.instagram && ( 
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href={`https://instagram.com/${sanitySiteSettings.socialLinks.instagram}`}
          variant="bigPrimary"
          sx={{
            ml: 3,
            p: 2,
          }}
        >
          <InstagramIcon height={14} width={14} alt="Follow us on Instagram" />
        </Button>
      )}
      {sanitySiteSettings.socialLinks.linkedin && ( 
        <Button
          target="_blank"
          rel="noopener noreferrer"
          href={`https://www.linkedin.com/${sanitySiteSettings.socialLinks.linkedin}/`}
          variant="bigPrimary"
          sx={{
            ml: 3,
            p: 2,
          }}
        >
          <LinkedinIcon height={14} width={14} alt="Follow us on LinkedIn" />
        </Button>
      )}
    </Flex>
  )
}

export default SocialLinks

const query = graphql`
  query SocialLinks {
    sanitySiteSettings {
      socialLinks {
        facebook
        twitter
        instagram
        linkedin
      }
    }
  }
`
